import { Dispatch } from 'redux';
import { SearchFormValues } from '../../../utils/helpers/search';

export type ChangeFuncType = <F extends keyof SearchFormValues>(
  name: F,
  value?: SearchFormValues[F] | undefined
) => void;

export interface RentalTabsProps {
  values: SearchFormValues;
}

export interface onClickProps {
  change: ChangeFuncType;
  dispatch: Dispatch;
  values: SearchFormValues;
}

export enum RentalTabsIdEnum {
  buyTab = 'buy-link',
  rentTab = 'rent-link',
  rentDailyTab = 'paid_daily-link',
  pashaTab = 'pasha-link'
}
